$(document).ready(function() {
  $( ".product-options__value" ).on( "click", function() {
    setTimeout(function () {
     $(".product-page-info__price .price").each(function() {
        $.pprspan = $(this).find("span") ;
        $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
        //console.log($.ppr);
        $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);
        $(this).next().find(".ex-gst").text($.pprconvert);
      });
         $(".product-page-info__price .price--sale").each(function() {
            $.pprspan = $(this).find(".og_price");
            $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
            //console.log($.ppr);
            $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);
        
            $(this).next().find(".ex-gst").text($.pprconvert);
         });
      }, 300); 
  });
  $(".product-page-info__price .price--sale").each(function() {
    $.pprspan = $(this).find(".og_price");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    //console.log($.ppr);
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
   $(".product-page-info__price .price").each(function() {
    $.pprspan = $(this).find("span") ;
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    //console.log($.ppr);
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
  
  $(".product-collection__price .price--sale").each(function() {
    $.pprspan = $(this).find(".og_price");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
 $(".product-collection__price .price").each(function() {
    $.pprspan = $(this).find("span") ;
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
  
  $(".product-cart__price-value .price--sale").each(function() {
    $.pprspan = $(this).find(".og_price");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
    $(".product-cart__price-value .price").each(function() {
    $.pprspan = $(this).find("span");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
   $(".popup-cart__subtotal .price--sale").each(function() {
    $.pprspan = $(this).find(".og_price");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
  $(".popup-cart__subtotal .price").each(function() {
    $.pprspan = $(this).find("span");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });

    $(".product-search-2__price .price--sale").each(function() {
    $.pprspan = $(this).find(".og_price");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });

 //  $(".product-search-2__price .price").each(function() {
 //    $.pprspan = $(this).find("span")[1];
 //    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
 //    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

 //    $(this).next().find(".ex-gst").text($.pprconvert);

 //  });
 // $(".product-search-2__price .price--sale").each(function() {
 //   $.pprspan = $(this).find(".og_price");
 //    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
 //    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

 //    $(this).next().find(".ex-gst").text($.pprconvert);

 //  });
  $(".cart__items .price--sale").each(function() {
    $.pprspan = $(this).find(".og_price");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
  
  $(".cart__items .price").each(function() {
    $.pprspan = $(this).find("span");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
    $(".footbar-product__price .price--sale").each(function() {
    $.pprspan = $(this).find(".og_price");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
  
  $(".footbar-product__price .price").each(function() {
    $.pprspan = $(this).find("span");
    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

    $(this).next().find(".ex-gst").text($.pprconvert);

  });
  $("#registration-form-btn").click(function() {
    $("#login-form").hide();
    $("#registration-form").show();
  });
  $("#login-form-btn").click(function() {
    $("#registration-form").hide();
    $("#login-form").show();
  });
});
 $('#Search').on('input', function() {
   setTimeout(function() {
      // $(".product-search-2__price .price").each(function() {
      //   $.pprspan = $(this).find("span");
      //   $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
      //   $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

      //   $(this).next().find(".ex-gst").text($.pprconvert);

      // });
      
     //  $(".product-search__price .price--sale").each(function() {
     //      $.pprspan = $(this).find("span")[1];
     //      console.log($.pprspan);
     //      $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
     //      $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);
      
     //      $(this).next().find(".ex-gst").text($.pprconvert);
      
     //    });
     // $(".product-search-2__price .price--sale").each(function() {
     //    $.pprspan = $(this).find("span")[1];
     //    $.ppr = parseFloat($.pprspan.text().substring(1, $.pprspan.text().length).replace(",", ""));
     //    $.pprconvert = parseFloat($.ppr * 10 / 11).toFixed(2);

     //    $(this).next().find(".ex-gst").text($.pprconvert);

     //  });
    }, 500);
});
